import React from "react";
import { CardButton, Label, ValueContainer, Value, Unit } from "./styles";

interface MetricCardProps {
	title: string;
	value: number;
	unit: string;
	accentColor: string;
	onClick: () => void;
}

const MetricCard: React.FC<MetricCardProps> = ({
	title,
	value,
	unit,
	accentColor,
	onClick,
}) => {
	return (
		<CardButton
			accentColor={accentColor}
			onClick={onClick}
			type="button"
			aria-label={`${title}: ${value} ${unit}`}
		>
			<Label>{title}</Label>
			<ValueContainer>
				<Value>{value}</Value>
				<Unit>{unit}</Unit>
			</ValueContainer>
		</CardButton>
	);
};

export default MetricCard;
